import React from 'react'

import spacingWrapper from 'Utilities/HigherOrderComponents/spacingWrapper'

const SpacingInternal = ({ children, className }) => {
  return <div className={className}>{children}</div>
}

export default spacingWrapper(SpacingInternal)
